import React, { useState } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage, auth } from '../firebase';

const ImageUploader = ({
  onUploadSuccess,
  currentImageUrl,
  label = "Immagine",
  storagePath = "images",
  showPreview = true,
  buttonText = "Carica Immagine"  // Nuova prop per il testo del pulsante
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      setError('');
    } else {
      setError('Seleziona un file immagine valido (JPG, PNG)');
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError('Seleziona un file prima di caricare');
      return;
    }

    setIsUploading(true);
    setError('');
    setUploadProgress(0);

    try {
      const timestamp = Date.now();
      const fileName = `${timestamp}_${selectedFile.name.replace(/\s+/g, '_')}`;
      const storageRef = ref(storage, `${storagePath}/${fileName}`);

      const metadata = {
        contentType: selectedFile.type,
        customMetadata: {
          uploadedBy: auth.currentUser?.uid || 'unknown',
          originalName: selectedFile.name
        }
      };

      const uploadTask = uploadBytesResumable(storageRef, selectedFile, metadata);

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(progress);
        },
        (error) => {
          console.error('Errore nel caricamento:', error);
          let errorMessage = 'Errore nel caricamento del file';
          switch (error.code) {
            case 'storage/unauthorized': errorMessage = 'Permessi insufficienti'; break;
            case 'storage/canceled': errorMessage = 'Caricamento annullato'; break;
            case 'storage/unknown': errorMessage = 'Errore sconosciuto'; break;
            case 'storage/quota-exceeded': errorMessage = 'Spazio esaurito'; break;
            default: errorMessage = `Errore: ${error.message}`;
          }
          setError(errorMessage);
          setIsUploading(false);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            onUploadSuccess(downloadURL);
          } catch (error) {
            console.error('Errore nel recupero URL:', error);
            setError('Errore nel recupero del link al file');
          } finally {
            setIsUploading(false);
            setSelectedFile(null);
          }
        }
      );
    } catch (error) {
      console.error('Errore iniziale:', error);
      setError(`Errore iniziale: ${error.message}`);
      setIsUploading(false);
    }
  };

  return (
    <div className="image-uploader">
      <div className="mb-3">
        {showPreview && currentImageUrl && (
          <div className="mb-3 text-center">
            <img
              src={currentImageUrl}
              alt="Anteprima"
              style={{ maxWidth: '100%' }}
            />
          </div>
        )}

        <label className="form-label">{label}</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="form-control"
          disabled={isUploading}
        />

        {error && <div className="text-danger small mt-2">{error}</div>}

        {selectedFile && !isUploading && (
          <button
            type="button"
            className="btn btn-primary mt-2"
            onClick={handleUpload}
          >
            <i className="bi bi-cloud-arrow-up me-2"></i> {buttonText}
          </button>
        )}

        {isUploading && (
          <div className="mt-3">
            <div className="progress mb-2">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${uploadProgress}%` }}
              >
                {Math.round(uploadProgress)}%
              </div>
            </div>
            <div className="text-muted-brand small">Caricamento in corso</div>
          </div>
        )}
                  <div className="small text-muted-brand text-center mt-1">
            Consigliato: scegli un immagine quadrata con sfondo trasparente (min. 300x300px)
          </div>
      </div>
      
    </div>
  );
};

export default ImageUploader;